<template>
  <section>
    <div>
      <hr>
      <b-tabs
        v-model="tabIndex"
        small
        content-class="mt-3"
        @activate-tab="clickedTab"
      >
        <b-tab
          ref="listTab"
          title="Lista"
          active
        >
          <SiteResultTable
            @sort-changed="onSort"
            @exclude-rows="onExcludeRows"
          />
        </b-tab>
        <b-tab
          title="Räckvidd och frekvens"
          :disabled="!hasSelection"
        >
          <SiteReach @onSiteSearchReach="siteSearchReach" />
        </b-tab>
        <template v-slot:tabs-end>
          <div
            v-if="tabIndex === 0"
            class="sumexportbtnswrapper"
          >
            <b-button
              variant="primary"
              size="sm"
              class="mr-2"
              :disabled="measuresInTable.length === 0"
              @click="showOrHideSumInTable"
            >
              {{ sumVisible ? "Göm Summering" : "Visa Summering" }}
            </b-button>
            <b-button
              size="sm"
              variant="success"
              @click="exportResult"
            >
              <b-icon
                icon="arrow-repeat"
              />
              Exportera
            </b-button>
          </div>
        </template>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import SiteResultTable from './SiteResultTable.vue';
import SiteReach from './SiteReach.vue';
import { mapActions } from 'vuex';
import { bus } from '../../../main';
import { downloadFile } from '../../../assets/js/api.js';

export default {
  name: 'SiteResult',
  components: {
    SiteResultTable,
    SiteReach,
  },
  data() {
    return {
      tabIndex: 0
    }
  },
  computed: {
    sumVisible() {
      return this.$store.getters[`siteResults/getSumVisible`];
    },
    hasSelection() {
      return this.$store.state.siteReachApiBody.payload.queryKeys.length > 0;
    },
    measuresInTable() {
      return this.$store.getters[`siteResults/getMeasuresInTable`];
    },
    hasExcludedRows() {
      let result = this.$store.state.siteResults
      return result.totalRowCount !== result.results.length;
    },
  },
  mounted() {
    bus.$on('searching', () => {
      if (this.$refs.listTab !== undefined) {
        this.$refs.listTab.activate();
        this.$store.commit('siteReachApiBody/emptyQueryKeys');
        this.$store.commit('siteResults/unselectAll');
      }
    });
  },
  methods: {
    ...mapActions(['siteSearchReach']),
    onSort(item) {
      this.$emit('sort-only', item);
    },
    onExcludeRows(rows) {
      this.$emit('exclude-rows', rows);
    },
    async clickedTab(newTabIndex, prevTabIndex) {
      if(newTabIndex === prevTabIndex) return
      if (newTabIndex === 1)
        this.siteSearchReach()
    },
    showOrHideSumInTable(){
      this.$store.commit('siteResults/setSumVisible', !this.sumVisible);
    },
    async exportResult() {
      try {
        let payload = {...this.$store.state.siteApiBody};
        await downloadFile('QuerySiteData/DownloadExport', payload);
      } catch (error) {
        console.error('Failed to export results:', error);
        // Show error to user
        this.$bvToast.toast('Ett fel uppstod vid export av data. Försök igen senare.', {
          title: 'Export misslyckades',
          variant: 'danger',
          solid: true
        });
      }

    },
  },
};
</script>
